<template>
  <div class="flex flex-col gap-8">
    <PdpCheckIconWithLabel label="Telias nät" />
    <PdpCheckIconWithLabel
      label="Spara oanvänd surf"
      sub-label="Upp till 100 GB"
    />
    <PdpCheckIconWithLabel
      label="Fria samtal och sms"
      :sub-label="`Hemma och inom EU `"
    />
  </div>
</template>

<script lang="ts" setup></script>

<style></style>
